import { combineReducers } from 'redux'

// Action Types
export const FETCH_TBT_SETTINGS_REQUEST = 'FETCH_TBT_SETTINGS_REQUEST'
export const FETCH_TBT_SETTINGS_SUCCESS = 'FETCH_TBT_SETTINGS_SUCCESS'
export const FETCH_TBT_SETTINGS_FAILURE = 'FETCH_TBT_SETTINGS_FAILURE'

export const FETCH_TBT_RUNS_REQUEST = 'FETCH_TBT_RUNS_REQUEST'
export const FETCH_TBT_RUNS_SUCCESS = 'FETCH_TBT_RUNS_SUCCESS'
export const FETCH_TBT_RUNS_FAILURE = 'FETCH_TBT_RUNS_FAILURE'

export const FETCH_RUN_DETAILS_REQUEST = 'FETCH_RUN_DETAILS_REQUEST'
export const FETCH_RUN_DETAILS_SUCCESS = 'FETCH_RUN_DETAILS_SUCCESS'
export const FETCH_RUN_DETAILS_FAILURE = 'FETCH_RUN_DETAILS_FAILURE'

export const MANUAL_TBT_RUN_REQUEST = 'MANUAL_TBT_RUN_REQUEST'
export const MANUAL_TBT_RUN_SUCCESS = 'MANUAL_TBT_RUN_SUCCESS'
export const MANUAL_TBT_RUN_FAILURE = 'MANUAL_TBT_RUN_FAILURE'

export const FETCH_TBT_DOCUMENTS_REQUEST = 'FETCH_TBT_DOCUMENTS_REQUEST'
export const FETCH_TBT_DOCUMENTS_SUCCESS = 'FETCH_TBT_DOCUMENTS_SUCCESS'
export const FETCH_TBT_DOCUMENTS_FAILURE = 'FETCH_TBT_DOCUMENTS_FAILURE'

export const UPLOAD_TBT_DOCUMENT_REQUEST = 'UPLOAD_TBT_DOCUMENT_REQUEST'
export const UPLOAD_TBT_DOCUMENT_SUCCESS = 'UPLOAD_TBT_DOCUMENT_SUCCESS'
export const UPLOAD_TBT_DOCUMENT_FAILURE = 'UPLOAD_TBT_DOCUMENT_FAILURE'

export const DELETE_TBT_DOCUMENT_REQUEST = 'DELETE_TBT_DOCUMENT_REQUEST'
export const DELETE_TBT_DOCUMENT_SUCCESS = 'DELETE_TBT_DOCUMENT_SUCCESS'
export const DELETE_TBT_DOCUMENT_FAILURE = 'DELETE_TBT_DOCUMENT_FAILURE'

export const TOGGLE_TBT_DOCUMENT_REQUEST = 'TOGGLE_TBT_DOCUMENT_REQUEST'
export const TOGGLE_TBT_DOCUMENT_SUCCESS = 'TOGGLE_TBT_DOCUMENT_SUCCESS'
export const TOGGLE_TBT_DOCUMENT_FAILURE = 'TOGGLE_TBT_DOCUMENT_FAILURE'

export const FETCH_TBT_STATISTICS_REQUEST = 'FETCH_TBT_STATISTICS_REQUEST'
export const FETCH_TBT_STATISTICS_SUCCESS = 'FETCH_TBT_STATISTICS_SUCCESS'
export const FETCH_TBT_STATISTICS_FAILURE = 'FETCH_TBT_STATISTICS_FAILURE'

// Settings Reducer
const settingsInitialState = {
  data: {},
  fetching: false,
  error: null,
}

const settings = (state = settingsInitialState, action) => {
  switch (action.type) {
    case FETCH_TBT_SETTINGS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case FETCH_TBT_SETTINGS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload,
        error: null,
      }
    case FETCH_TBT_SETTINGS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    default:
      return state
  }
}

// Runs Reducer
const runsInitialState = {
  data: [],
  fetching: false,
  error: null,
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  filters: {},
  sorter: {},
}

const runs = (state = runsInitialState, action) => {
  switch (action.type) {
    case FETCH_TBT_RUNS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case FETCH_TBT_RUNS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.data,
        pagination: {
          ...state.pagination,
          current: action.payload.current_page,
          total: action.payload.total,
          pageSize: action.payload.per_page,
        },
        error: null,
      }
    case FETCH_TBT_RUNS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    default:
      return state
  }
}

// Run Details Reducer
const runDetailsInitialState = {
  data: {},
  fetching: false,
  error: null,
}

const runDetails = (state = runDetailsInitialState, action) => {
  switch (action.type) {
    case FETCH_RUN_DETAILS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case FETCH_RUN_DETAILS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          [action.payload.id]: action.payload,
        },
        error: null,
      }
    case FETCH_RUN_DETAILS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    default:
      return state
  }
}

// Manual Run Reducer
const manualRunInitialState = {
  data: null,
  loading: false,
  error: null,
}

const manualRun = (state = manualRunInitialState, action) => {
  switch (action.type) {
    case MANUAL_TBT_RUN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case MANUAL_TBT_RUN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      }
    case MANUAL_TBT_RUN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

// Documents Reducer
const documentsInitialState = {
  data: [],
  fetching: false,
  error: null,
  uploading: false,
  uploadError: null,
}

const documents = (state = documentsInitialState, action) => {
  switch (action.type) {
    case FETCH_TBT_DOCUMENTS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case FETCH_TBT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.rows || action.payload,
        error: null,
      }
    case FETCH_TBT_DOCUMENTS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    case UPLOAD_TBT_DOCUMENT_REQUEST:
      return {
        ...state,
        uploading: true,
        uploadError: null,
      }
    case UPLOAD_TBT_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploading: false,
        data: [action.payload.document, ...state.data],
        uploadError: null,
      }
    case UPLOAD_TBT_DOCUMENT_FAILURE:
      return {
        ...state,
        uploading: false,
        uploadError: action.payload,
      }
    case DELETE_TBT_DOCUMENT_SUCCESS:
      return {
        ...state,
        data: state.data.filter(doc => doc.id !== action.payload.id),
      }
    case TOGGLE_TBT_DOCUMENT_SUCCESS:
      return {
        ...state,
        data: state.data.map(doc => 
          doc.id === action.payload.id 
            ? { ...doc, active: !doc.active }
            : doc
        ),
      }
    default:
      return state
  }
}

// Statistics Reducer
const statisticsInitialState = {
  data: {},
  fetching: false,
  error: null,
}

const statistics = (state = statisticsInitialState, action) => {
  switch (action.type) {
    case FETCH_TBT_STATISTICS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case FETCH_TBT_STATISTICS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload,
        error: null,
      }
    case FETCH_TBT_STATISTICS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default combineReducers({
  settings,
  runs,
  runDetails,
  manualRun,
  documents,
  statistics,
})
